import type { CardInput, CardRegister, CompanyCard } from '@/types/card';
import { postEdgeFunctionAction } from './postEdgeFunctionAction';

/** The company card register (card-api). Every call names the company: a consultant may act on several. */
export class CardApiClient {
  async listCards(companyId: string): Promise<CardRegister> {
    return postEdgeFunctionAction<CardRegister>('card-api', 'list', { companyId });
  }

  async createCard(companyId: string, input: CardInput): Promise<CompanyCard> {
    const { card } = await postEdgeFunctionAction<{ card: CompanyCard }>('card-api', 'create', { companyId, ...input });
    return card;
  }

  async updateCard(companyId: string, cardId: string, input: CardInput): Promise<CompanyCard> {
    const { card } = await postEdgeFunctionAction<{ card: CompanyCard }>('card-api', 'update', { companyId, cardId, ...input });
    return card;
  }

  async deleteCard(companyId: string, cardId: string): Promise<void> {
    await postEdgeFunctionAction('card-api', 'delete', { companyId, cardId });
  }
}
